var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailCardIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1433_31094)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1433_31094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9375 5.0625H18.8125V0.9375C18.8125 0.41975 18.3928 0 17.875 0C17.3572 0 16.9375 0.41975 16.9375 0.9375V5.0625Z",
    fill: "#39326C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1875 5.0625H15.0625V0.9375C15.0625 0.41975 14.6428 0 14.125 0C13.6072 0 13.1875 0.41975 13.1875 0.9375V5.0625Z",
    fill: "#5F55AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.875 32C18.3928 32 18.8125 31.5802 18.8125 31.0625V26.9375H16.9375V31.0625C16.9375 31.5802 17.3572 32 17.875 32Z",
    fill: "#39326C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.125 32C14.6428 32 15.0625 31.5802 15.0625 31.0625V26.9375H13.1875V31.0625C13.1875 31.5802 13.6072 32 14.125 32Z",
    fill: "#5F55AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.9375 15.0625H5.0625V13.1875H0.9375C0.41975 13.1875 0 13.6072 0 14.125C0 14.6428 0.41975 15.0625 0.9375 15.0625Z",
    fill: "#5F55AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.9375 18.8125H5.0625V16.9375H0.9375C0.41975 16.9375 0 17.3572 0 17.875C0 18.3928 0.41975 18.8125 0.9375 18.8125Z",
    fill: "#5F55AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9375 15.0625H31.0625C31.5802 15.0625 32 14.6428 32 14.125C32 13.6072 31.5802 13.1875 31.0625 13.1875H26.9375V15.0625Z",
    fill: "#39326C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9375 18.8125H31.0625C31.5802 18.8125 32 18.3928 32 17.875C32 17.3572 31.5802 16.9375 31.0625 16.9375H26.9375V18.8125Z",
    fill: "#39326C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.875 3.1875H4.125C3.60725 3.1875 3.1875 3.60725 3.1875 4.125V27.875C3.1875 28.3927 3.60725 28.8125 4.125 28.8125H27.875C28.3927 28.8125 28.8125 28.3927 28.8125 27.875V4.125C28.8125 3.60725 28.3927 3.1875 27.875 3.1875Z",
    fill: "#AED0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.125 6.9375H7.875C7.35725 6.9375 6.9375 7.35725 6.9375 7.875V24.125C6.9375 24.6427 7.35725 25.0625 7.875 25.0625H24.125C24.6427 25.0625 25.0625 24.6427 25.0625 24.125V7.875C25.0625 7.35725 24.6427 6.9375 24.125 6.9375Z",
    fill: "url(#paint0_linear_1433_31094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4769 12.0243C15.4737 12.0157 15.4703 12.0072 15.4668 11.9986C15.2953 11.5817 14.8933 11.3125 14.4426 11.3125C14.4422 11.3125 14.4418 11.3125 14.4415 11.3125C13.9903 11.3129 13.5883 11.5831 13.4175 12.0006C13.4147 12.0077 13.4118 12.0148 13.4092 12.0219L10.5929 19.4163C10.4086 19.9002 10.6515 20.4418 11.1353 20.6261C11.6192 20.8104 12.1608 20.5675 12.3451 20.0836L12.8165 18.8459H16.0472L16.5133 20.081C16.655 20.4564 17.0117 20.6877 17.3906 20.6877C17.5006 20.6877 17.6125 20.6683 17.7215 20.6271C18.2058 20.4443 18.4504 19.9034 18.2675 19.419L15.4769 12.0243ZM13.5307 16.9709L14.4393 14.5852L15.3397 16.9709H13.5307Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5312 11.3125C20.0135 11.3125 19.5938 11.7322 19.5938 12.25V19.75C19.5938 20.2677 20.0135 20.6875 20.5312 20.6875C21.049 20.6875 21.4688 20.2677 21.4688 19.75V12.25C21.4688 11.7322 21.049 11.3125 20.5312 11.3125Z",
    fill: "#F9F9F9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1433_31094",
    x1: 16,
    y1: 6.9375,
    x2: 16,
    y2: 25.0625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD55AF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1433_31094"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1433_31094"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailCardIcon5);
export default __webpack_public_path__ + "static/media/mail_card_icon5.e472e2289383792776804d5754e187c8.svg";
export { ForwardRef as ReactComponent };